// Design tokens — import this anywhere you need consistent values
export const DS = {
  bg:          "#0D0C18",
  surface:     "#161526",
  elevated:    "#1E1C30",
  borderFaint: "rgba(255,255,255,0.06)",
  border:      "rgba(255,255,255,0.10)",
  borderMid:   "rgba(255,255,255,0.16)",

  text:        "#E4E2F0",
  textMuted:   "rgba(228,226,240,0.50)",
  textFaint:   "rgba(228,226,240,0.28)",

  accent:      "#7366F0",
  accentDark:  "#5A4FD6",
  gold:        "#EDBB4A",
  goldGlow:    "rgba(237,187,74,0.25)",

  success:     "#4BB87A",
  danger:      "#E04646",
  warning:     "#E8A030",

  sq: 68,        // board square px
  radius: 12,    // standard card radius
  radiusSm: 8,
};
